export const TABLE_HEADERS = {
    TABLE_COLUMNS: ['checkbox', 'shiftStatus', 'careDate', 'careTime', 'location', 'holiday', 'staffType', 'promote', 'manage'],
    ACCEPTED_TABLE_COLUMNS: ['name', 'careDateTime', 'location', 'holiday', 'staffType', 'promote', 'manage'],
    BLOCK_BOOKING_COLUMNS: ['blockbookingsStatus', 'careDateRange', 'location', 'holiday', 'staffType', 'promote', 'manage'],
    BLOCK_BOOKING_COLUMNS_ACCEPTED: ['name', 'careDateRange', 'location', 'holiday', 'staffType', 'promote']
};
